import { render, staticRenderFns } from "./MyDetailsChange.vue?vue&type=template&id=08a1fb8a&scoped=true&"
import script from "./MyDetailsChange.vue?vue&type=script&lang=js&"
export * from "./MyDetailsChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1fb8a",
  null
  
)

export default component.exports